export default __webpack_public_path__ + "static/media/ind2.00c9485b.svg";